<template>
  <div>
    <nav-breadcrumb :menu="[{label: '待还款列表'}]"/>
    <div class="xzpadd10 bg-purple of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
      </div>
    <el-dialog :visible.sync="repayOfflineInfoDialogVisible" title="登记收款信息">
      <form-build :form-data="repayOfflineInfoForm" :form-columns="repayOfflineInfoColumns" :form-rules="repayOfflineInfoFormRules" :form-buttons="repayOfflineInfoButtons"></form-build>
    </el-dialog>
    <el-dialog :visible.sync="repayForApprovalDialogVisible" title="还款">
      <repay-for-approval :financing-detail="repayInfo" :transfer-repayment-detail="repayInfo" :repay-plan-list="repayInfo.detail" @close="repayForApprovalDialogVisible=false" @ok="handleRepayForApproval"></repay-for-approval>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisible5"
      width="30%">
      本次匹配还款后，余额为{{balanceAmount}}，此客户还有其他贷款未结算，你可以选择余额的处理方式：<br/>
      <el-radio v-model="radio" label="Y">不使用余额还其他贷款</el-radio><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <el-radio v-model="radioType" label="None">宕帐</el-radio>
      <el-radio v-model="radioType" label="Profit">转入营业外收入</el-radio>
      <el-radio v-model="radioType" label="Refund">返还客户</el-radio>
      <el-radio v-model="radioType" label="Refund-ToDealer">返还渠道商</el-radio><br/>
      <el-radio v-model="radio" label="N">若要将余额用于还其他贷款，请先手动拆分银行流水。</el-radio>
      <el-button @click="updateApproveSelect()">保存</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";

  import RepayForApproval from "../components/RepayForApproval";
  import payChannelOptions from "../../utils/payChannelOptions";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "RepayFinancingList",
    components: {RepayForApproval},
    data(){
      return{
        balanceAmount:0,
        split:'',
        radio:'',
        radioType:'',
        dialogVisible5:false,
        dialogVisible :false,
        payAccountList: [],
        loanAccountList: [],
        payTransactionId: '',
        payLoanAccount:'',
        transactionStatus: 'Pending Approval',
        tableData: {
          count: 0,
          data: []
        },
        dealerTypeOptions:[],
        page: 1,
        pageSize: 20,
        actions: [
          /*{
            label: '新增',
            class: 'el-icon-plus',
            clickHandler: ()=>{
              this.$router.push({
                path: 'add'
              })
            }
          }*/
        ],
        filters: {
          labelWidth: '150px',
          form: {
            c__customerName:'',
            c__customerContactNo:'',
            plan__repayDate:[],
            fi__transactionNo:'',
          },
          columns: [
            {
              label: '贷款编号',
              component: 'el-input',
              field: 'fi__transactionNo',

            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'c__customerName',

            },
            {
              label: '客户手机号',
              component: 'el-input',
              field: 'c__customerContactNo',

            },
            {
              label: '应还款日',
              component: 'date-range-picker',
              field: 'plan__repayDate',
              op: ['gteq', 'lteq'],
            },

          ],
          onSubmit:()=>{
            this.page = 1
            this.getData()
          }
        },
        repayOfflineInfoDialogVisible: false,
        repayOfflineInfoForm: {
          fi__transactionId: '',
          t__repayDate: '',
          t__totalAmount: '',
          t__channel: '',
          t__remarks: ''
        },
        repayOfflineInfoFormRules: {
          fi__transactionId: {
            required: true,
            message: '此项必填！'
          },
          t__repayDate: {
            required: true,
            message: '此项必填'
          },
          t__totalAmount: {
            required: true,
            message: '此项必填'
          }
        },
        repayOfflineInfoColumns: [
          {
            label: '贷款编号',
            field: 'fi__transactionNo',
            span: 24
          },
          {
            label: '客户姓名',
            field: 'c__customerName'
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
            formatter: function (c,v) {
              return formatMoney(v)
            }
          },
          {
            label: '日期',
            field: 't__repayDate',
            component: 'el-date-picker',
            type: 'date',
            valueFormat: 'yyyy-MM-dd 00:00:00'
          },
          {
            label: '金额',
            field: 't__totalAmount',
            component: 'el-input',
            type: 'number'
          },
          {
            label: '支付方式',
            field: 't__channel',
            component: 'el-select',
            options: payChannelOptions
          },
          {
            label: '备注',
            field: 't__remarks',
            component: 'el-input',
            span: 24
          }
        ],
        repayOfflineInfoButtons: [
          {
            label: '下一步',
            type: 'primary',
            clickHandler: $refs=> {
              $refs.validate(valid=> {
                if(valid) {
                  this.getRepayOfflineInfo()
                }

              })
            }
          }
        ],
        repayForApprovalDialogVisible: false,
        repayInfo: {}
      }
    },
    computed:{
      columns: function(){
        return [
          {
            type: 'index'
          },
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '客户姓名',
            field: 'c__customerName'
          },
          {
            label: '贷款开始日期',
            field: 'fi__startDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            label: '贷款结束日期',
            field: 'fi__endDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            label: '期数',
            field: 'plan__sequenceNo'
          },

          {
            label: '应还款日',
            field: 'plan__repayDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            label: '还款金额',
            field: 'plan__repayAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            label: '本金',
            field: 'plan__principalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            label: '利息',
            field: 'plan__interestAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          /*{
            label: '服务费',
            field: 'plan__lendingFeeAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },*/
          {
            label: '余额',
            field: 'bal__principalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            label: '操作',
            opts:[
              {
                label: '还款',
                component: 'el-button',
                size: 'mini',
                class: 'el-icon-check el-button--primary',
                type: 'primary',
                clickHandler: (index, row) => {
                  this.repayOfflineInfoDialogVisible = true

                  this.repayOfflineInfoForm = Object.assign({
                    fi__transactionId: row.fi__transactionId,
                    t__repayDate: '',
                    t__totalAmount: '',
                    t__channel: '',
                    t__remarks: ''
                  }, row)

                  // this.$router.push({
                  //   name: 'RepayFinancingView',
                  //   query: {
                  //     'entryId': row.plan__entryId,
                  //
                  //   }
                  // })
                },
                conditions: row=> {
                  return row.fi__transactionStatus=='Processing'

                }
              },



            ]
          }
        ]
      },
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.fi.transactionStatus' : 'Processing',
            'xlist.search.fi.transactionStatus.op' : 'in',
            'xlist.sort.dataField': 'fi.applicationDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },

    watch: {
      filterParams: function () {
        this.getData()
      },
    },

    mounted() {
      this.getData()
    },
    methods: {
      getData: function () {
        xhr.getOutstanding(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res => {
            try {
              this.tableData = res.data
            } catch (e) {

            }
          })
      },
      getRepayOfflineInfo: function () {
        xhr.getRepayOfflineInfo(
          JSON.parse(JSON.stringify(this.repayOfflineInfoForm).replace(/__/g, '.')),
          res => {
            if(res.data.status == 'success') {
              this.repayOfflineInfoDialogVisible = false
              this.repayForApprovalDialogVisible = true

              const repayInfo = res.data.data || {}
              repayInfo.detail.forEach(item=> {
                item.rex__expectedCompoundInterestChecked = 'N'
                item.rex__expectedOverdueFineChecked = 'N'
              })
              Object.assign(repayInfo, {de__txDate: this.repayOfflineInfoForm.t__repayDate}, this.repayOfflineInfoForm)

              this.repayInfo = repayInfo

            }
            else {
              this.$message.error((res.data.msgs||[]).map(item=>item.text).join(','))
            }

          }
        )
      },
      handleRepayForApproval: function () {
        let form = {
          detail:[]
        }
        let next = true
        if(this.split=='no'){
          form.t__excessAmountOption =  this.radioType
          form.split =  'no'
        }

        this.repayInfo.detail.forEach(item=> {
          let mm = {}
          mm.rex__exBalanceAmount = item.rex__exBalanceAmount
          mm.rex__appliedOverdueFine = item.rex__appliedOverdueFine
          mm.rex__appliedCompoundInterest = item.rex__appliedCompoundInterest

          mm.rex__appliedInterestAmount = item.rex__appliedInterestAmount
          mm.rex__appliedPrincipalAmount = item.rex__appliedPrincipalAmount
          mm.rex__excessAmount = item.rex__excessAmount
          mm.plan__entryId = item.plan__entryId


          mm.rex__waiveCompoundInterest = item.rex__waiveCompoundInterest
          mm.rex__waiveOverdueFine = item.rex__waiveOverdueFine

          mm.rex__extendingDays = item.rex__extendingDays||0
          mm.rex__extendingInterestAmount = item.rex__extendingInterestAmount||0
          if(parseFloat(item.rex__extendingDays)>parseFloat(this.repayInfo.t__gracePeriod)&&item.rex__extendible=='Y'){

            next = false
          }

          form.detail.push(mm)
        })
        form.de__candidates = this.repayInfo.de__candidates
        form.t__remarks = this.repayInfo.t__remarks
        form.t__repayDate = this.repayInfo.de__txDate
        form.t__totalAmount = this.repayInfo.t__totalAmount
        form.fi__transactionId = this.repayInfo.fi__transactionId
        form.t__channel = this.repayInfo.t__channel
        form.t__remarks = this.repayInfo.t__remarks

        if(!next){
          this.$alert('延期天数不能大于'+this.repayInfo.t__gracePeriod)
          return false
        }
        xhr.updateRepayForApproval(
          form,
          res=> {
            try{
              if(res.data.status == 'success') {
                this.split = ''
                this.radio = ''
                this.radioType= ''
                this.dialogVisible5=false
                this.repayForApprovalDialogVisible = false
                this.getData()
              }else{

                if(res.data.errdata.splittable){
                  if(res.data.errdata.balanceAmount>0){
                    this.balanceAmount = res.data.errdata.balanceAmount
                    this.dialogVisible5=true
                  }
                }
              }

            }catch (e) {

              this.$message.error(error.msgs[0].text)

            }
          }
        )
      },
      updateApproveSelect:function () {
        if(this.radio=='N'){
          this.dialogVisible5=false
          this.repayForApprovalDialogVisible = false
          this.radio = ''
        }else if(this.radio=='Y'){
          if(this.radioType!=''){
            this.split = 'no'
            this.handleRepayForApproval()
          }else{
            this.$message.error('请选择处理方式种类')
          }
        }else{
          this.$message.error('请选择处理方式')
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/RepayFinancingList.vue